import React from "react";

/*
Usage
<Cta />
*/

export default function CTA() {
  return (
    <div className="bg-white mt-4">
      <div className=" flex flex-col flex-grow bg-[#3333e6] rounded-xl text-center sm:py-8 sm:px-6 lg:px-8">
        <div>
          <span className="mt-4 text-3xl text-white">Intervention rapide</span>
          <br />
          <span className="mt-1 text-m text-blue-200">sous 48h</span>
        </div>
        <a
          target="_blank"
          rel="nofollow"
          href="https://app.blicko.fr/login"
          className="no-underline inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-xl text-white bg-orange-600 hover:bg-orange-700 sm:w-auto"
        >
          Envoyer une vidéo de mon problème de plomberie aux plombiers
        </a>
      </div>
    </div>
  );
}
